export const SERVICE_OPTIONS = [
  'Cookie Wow',
  'PDPA Form',
  'PDPA Prokit',
  'LearnPDPA',
  'PDPA Pro',
] as const
